import { render, staticRenderFns } from "./FileUploadTest.vue?vue&type=template&id=20082c96&"
import script from "./FileUploadTest.vue?vue&type=script&lang=js&"
export * from "./FileUploadTest.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports